import { SET_VIEWPORT, SET_PAGE_VISIBILITY } from '@/store/viewport/mutation-types'

export function setViewport({ commit }, { width, height }) {
  commit(SET_VIEWPORT, { width, height })
}

export function setPageVisibility({ commit }, { hidden }) {
  commit(SET_PAGE_VISIBILITY, { hidden })
}
